import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { registerNotificationsForUser } from "src/requests/notifications/requests";
import {
  notificationsConnection,
  runSignalrAction,
} from "src/requests/signalRConnections";
import { isNativeApp } from "src/utils/nativeUtils";
import { NotificationId } from "../../globalTypes";
import { useFetchTemplateMetadataForTemplateIds } from "../templateMetadata/hooks/useActions";
import { resolveNotifications } from "./actionCreators";
import {
  fetchAllNotificationsThunk,
  resolveNotificationsThunk,
} from "./thunks";
import { useMissingTemplateIdsForNotifications } from "./useSelectors";

export * from "./system/useActions";

export const useDismissNotification = () => {
  const dispatch = useDispatch();

  return (id: NotificationId) => dispatch(resolveNotificationsThunk([id]));
};

export const useDismissNotfications = () => {
  const dispatch = useDispatch();

  return (ids: NotificationId[]) => dispatch(resolveNotificationsThunk(ids));
};

export const useResolveNotification = () => {
  const dispatch = useDispatch();

  return (notificationId: NotificationId) =>
    dispatch(resolveNotifications({ notificationIds: [notificationId] }));
};

export const useFetchAllNotifications = () => {
  const dispatch = useDispatch();
  return useCallback(() => dispatch(fetchAllNotificationsThunk()), [dispatch]);
};

export const useRegisterAndFetchInitialNotifications = () => {
  const fetchNotifications = useFetchAllNotifications();
  useEffect(() => {
    const registerAndFetch = async (connectionId?: string | null) => {
      if (!connectionId) return;

      try {
        await registerNotificationsForUser(connectionId);

        fetchNotifications();
      } catch (e) {
        console.error("Erorr during registering notificatons", e);
      }
    };

    runSignalrAction(notificationsConnection, registerAndFetch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const useFetchTemplatesForNotificationsAutofetch = () => {
  const templateIds = useMissingTemplateIdsForNotifications();
  const fetchTemplates = useFetchTemplateMetadataForTemplateIds();

  useEffect(() => {
    if (templateIds.length) {
      fetchTemplates(templateIds);
    }
  }, [templateIds, fetchTemplates]);
};
